import React, { useState, useEffect } from "react";
import "./Gallery.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Dynamisches Laden aller Bilder aus src/assets2
const importAll = (r) => r.keys().map(r);
const images = importAll(require.context("../../assets2", false, /\.(png|jpe?g|webp)$/));

function Gallery() {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: false });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  const handlePrev = () => {
    setAnimate(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
      setAnimate(false);
    }, 300);
  };

  const handleNext = () => {
    setAnimate(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
      setAnimate(false);
    }, 300);
  };

  return (
    <section className="gallery-container" id="gallery">
      <div className="container">
        <h2 className="section-title">Galerie</h2>
        <div className="gallery-wrapper">
          <button className="gallery-arrow left" onClick={handlePrev}>
            &#10094;
          </button>
          <div className="gallery-image-wrapper">
            <img
              src={images[currentIndex]}
              className={`gallery-image ${animate ? "fade-out" : "fade-in"}`}
              alt={`Bild ${currentIndex + 1}`}
            />
          </div>
          <button className="gallery-arrow right" onClick={handleNext}>
            &#10095;
          </button>
        </div>
      </div>
    </section>
  );
}

export default Gallery;
